import { useEffect, useRef } from 'react';

export function useModifierOpen() {
  const ref = useRef(false);
  useEffect(() => {
    function down(e: KeyboardEvent | MouseEvent) {
      ref.current = 'metaKey' in e ? e.metaKey || e.ctrlKey : false;
    }
    function up() {
      ref.current = false;
    }
    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    window.addEventListener('mousedown', down);
    window.addEventListener('mouseup', up);
    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
      window.removeEventListener('mousedown', down);
      window.removeEventListener('mouseup', up);
    };
  }, []);
  return ref;
}
